import CardDots from "@/Components/DataDisplayCompoants/CardDots";
import React from "react";

type BannerCardProps = {
  title: string;
  theme: "blue" | "green";
  onclick?: () => void;
};

const BannerCard: React.FC< BannerCardProps> = ({ title, theme, onclick  }) =>  {
  const isBlue = theme === "blue";

  return (
    <div
      className={`cursor-pointer xl:py-11 py-6 flex items-center px-6 shadow-[0_16px_72px_-10px_#001A2D3D] relative h-full overflow-hidden xl:max-h-[115px] lg:max-h-[99px] lg:min-h-auto min-h-[99px]
        after:content-[''] after:absolute after:w-[94px] after:h-[192px] after:bottom-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
        before:content-[''] before:absolute before:w-full before:h-full before:max-h-full before:top-0 before:right-0 before:bg-cover before:bg-no-repeat before:bg-center
        ${
          isBlue
            ? "bg-blue-50 after:bg-[url(/images/ServicesPage/card-blur-right.svg)] before:bg-[url(/images/ServicesPage/card-bg-blue.svg)] before:will-change-transform"
            : "bg-green-50 after:bg-[url(/images/ServicesPage/card-green-right.svg)] before:bg-[url(/images/ServicesPage/card-bg-green.svg)] before:will-change-transform"
        }
      `}
      onClick={() => {
        if (onclick) {
          onclick();
        }
      }}
    >
      <CardDots />
      <div className="relative z-10">
        <h6 className="text-subtitle-1 font-bold text-primary-text">{title}</h6>
      </div>
    </div>
  );
};
export default BannerCard;